import { productsFragment } from '@pylot-data/hooks/search/graphql/productsFragment'
import { categoryFragment } from '@pylot-data/hooks/search/graphql/categoryFragment'
// TODO: once support for UIDs is added, start utilizing categoryQuery
export const oldCategoryQuery = /* GraphQL */ `
    query categories($categoryFilter: CategoryFilterInput) {
        categories(filters: $categoryFilter) {
            items {
                name
                url_key
                url_path
                level
                uid
                meta_title
                meta_keywords
                meta_description
                display_mode
                alfa_description
                category_banner
                description
                image_disruptor
                cms_block {
                    content
                }
                ${categoryFragment}
                breadcrumbs {
                    category_level
                    category_name
                    category_url_key
                    category_url_path
                    __typename
                }
                children {
                    name
                    uid
                    url_path
                    url_key
                }
                image
            }
        }
    }
`

export const productsQuery = /* GraphQL */ `
    query products($filter: ProductAttributeFilterInput, $search: String = "", $pageSize: Int = 10, $currentPage: Int = 1, $sort: ProductAttributeSortInput = {}){
        products(
            filter: $filter
            search: $search
            pageSize: $pageSize
            currentPage: $currentPage
            sort: $sort
        ) {
            ${productsFragment}
        }
    }
`

export const productSearchQuery = /* GraphQL */ `
    query products($search: String = '', $filter: ProductAttributeFilterInput, $pageSize: Int = 10, $currentPage: Int = 1, $sort: ProductAttributeSortInput = {}){
        products(
            search: $search
            filter: $filter
            pageSize: $pageSize
            currentPage: $currentPage
            sort: $sort
        ) {
            ${productsFragment}
        }
    }
`

export const categoryQuery = /* GraphQL */ `
    query categories(
        $categoryFilter: CategoryFilterInput
        $pageSize: Int = 12
        $currentPage: Int = 0
        $filter: ProductAttributeFilterInput = {}
        $sort: ProductAttributeSortInput = {}
    ) {
        categories(filters: $categoryFilter) {
            items {
                name
                url_key
                url_path
                uid
                meta_title
                meta_keywords
                meta_description
                display_mode
                alfa_description
                category_banner
                description
                level
                image_disruptor
                cms_block {
                    content
                }
                ${categoryFragment}
                breadcrumbs {
                    category_level
                    category_name
                    category_url_key
                    category_url_path
                    __typename
                }
                children {
                    name
                    uid
                    url_key
                    url_path
                }
            }
        }
        products(
            pageSize: $pageSize
            currentPage: $currentPage
            filter: $filter
            sort: $sort
        ) {
            aggregations {
                __typename
                attribute_code
                count
                label
                options {
                    __typename
                    label
                    value
                    count
                }
            }
            __typename
            sort_fields {
                __typename
                default
                options {
                    __typename
                    label
                    value
                }
            }
            items {
                __typename
                id
                name
                stock_status
                price_range {
                    __typename
                    minimum_price {
                        __typename
                        regular_price {
                            __typename
                            value
                            currency
                        }
                        final_price {
                            __typename
                            value
                            currency
                        }
                        discount {
                            __typename
                            amount_off
                        }
                    }
                }
                sku
                small_image {
                    __typename
                    url
                }
                url_key
                ... on ConfigurableProduct {
                    configurable_options {
                        __typename
                        attribute_code
                        attribute_id
                        attribute_uid
                        id
                        label
                        values {
                            __typename
                            value_index
                            uid
                            label
                            swatch_data {
                                __typename
                                value
                                ... on ImageSwatchData {
                                    thumbnail
                                    __typename
                                }
                            }
                        }
                    }
                    variants {
                        __typename
                        attributes {
                            __typename
                            code
                            value_index
                            label
                        }
                        product {
                            __typename
                            id
                            small_image {
                                __typename
                                url
                            }
                            sku
                            stock_status
                        }
                    }
                    __typename
                }
            }
            page_info {
                __typename
                total_pages
            }
            total_count
        }
    }
`
